import * as React from 'react';

import { Alert } from '@components/common';
import { PlusSquareSVG } from '@components/svgs/PlusSquareSVG';

import { RuleContainer } from '../RuleBuilder/RuleContainer';

import { useQuestionRulesContext } from './QuestionRulesContext';

export const QuestionConfigContainer: React.FC = () => {
  const {
    groupedRules,
    toggleOutcome,
    updateRuleLogic,
    updateRuleOutcome,
    duplicateRule,
    removeRule,
    addRule,
    keyCounter,
    question,
    screener,
    validationErrors,
    conflictingRuleIndexes
  } = useQuestionRulesContext();

  return (
    <div className='space-y-4 p-4'>
      <div className='space-y-4'>
        <span className='font-bold leading-6'>{`If Q${question.position}: ${question.label || '(Untitled question)'}`}</span>
        {validationErrors && (
          <Alert type='error' heading='Conflicting rules'>
            2 or more rules have conflicting logic. Please resolve before saving.
          </Alert>
        )}
      </div>

      {groupedRules.map((rule, ruleIndex) => (
        <RuleContainer
          key={`rule_container_${ruleIndex}_${keyCounter}`}
          rule={rule}
          ruleIndex={ruleIndex}
          question={question}
          screenerFields={screener.fields}
          onUpdateRuleLogic={(operator, answer_value) => updateRuleLogic(ruleIndex, operator, answer_value)}
          onUpdateRuleOutcome={(outcomeIndex, outcome) => updateRuleOutcome(ruleIndex, outcomeIndex, outcome)}
          onRemoveRule={removeRule}
          onToggleOutcome={toggleOutcome}
          onDuplicateRule={duplicateRule}
          groupedRules={groupedRules}
          allowedOutcomeTypes={screener.screener_type === 'pre' ? ['skip_to', 'ideal', 'disqualifying'] : ['skip_to']}
          isConflicting={conflictingRuleIndexes.has(ruleIndex)}
        />
      ))}
      <button className='focus:outline-none ml-auto flex items-center gap-2 px-2 py-4' onClick={addRule}>
        <PlusSquareSVG />
        Add Rule
      </button>
    </div>
  );
};
